import {useEffect, useState} from 'react'
import { Box, Button } from "@chakra-ui/react";
import { optionTypes } from "../../dsr-draft/page-designer/types/subWidgetOptionsTypes";
import { openInNewTab } from '../../../global/helpers/global-helpers';
import { updateTagWithoutRender } from '../../../global/helpers/url-tag-helpers';

const PublishedDsrCtaButtonDisplay = ({ subWidgetContent, subWidgetOptions }) => {
 
 
  const [isInternalLink, setIsInternalLink] = useState(false)
  const [buttonText, setButtonText] = useState("CTA Button")
  const [link, setLink] = useState("")
  // const [pageType, setPageType] = useState(null)

  
  useEffect(() => {
    if (subWidgetContent) {
      if (subWidgetContent.includes("/?intl")) {
        const ctaText = subWidgetContent ? subWidgetContent.split('/?intl/')[0] : "CTA Button";
        const ctaLink = subWidgetContent ? subWidgetContent.split('/?intl/')[1] : "https://www.google.com";
        const internalPage = ctaLink.split('?pageType=')[0]
        // const pageType = ctaLink.split('?pageType=')[1]
        setButtonText(ctaText)
        setLink(internalPage)
        // setPageType(pageType ? pageType : "essential")
        setIsInternalLink(true)
      } else {
        // Is External Link
        const ctaText = subWidgetContent ? subWidgetContent.split('/?&/')[0] : "CTA Button";
        const ctaLink = subWidgetContent ? subWidgetContent.split('/?&/')[1] : "https://www.google.com";
        setButtonText(ctaText)
        setLink(ctaLink)
        // setPageType('external')
        setIsInternalLink(false)
      }
    }
  }, [subWidgetContent]);

  let buttonAlign = subWidgetOptions[optionTypes.ALIGN];
  let buttonVariant = subWidgetOptions[optionTypes.VARIANT];

  const handleClickButton = () => {
    if (isInternalLink) {
       updateTagWithoutRender('viewpage',link)
    } else {
      link && openInNewTab(link)
    }
  }

  
  return (
    <Box display='flex' justifyContent={buttonAlign ? buttonAlign : 'center'} padding="10px">
      <Button
        onClick={() => handleClickButton()}
        bg={buttonVariant === 'primary' ? 'brandDark.500' : '#EAF4FD'}
        color={buttonVariant === 'primary' ? 'white' : '#3295EC'}
        _hover={{ color: "gray.50", bg: "brand.600" }}
        transition="color 0.2s ease-in-out, background 0.2s ease-in-out"
        fontSize='0.875em'
        rounded='0.85em'
        px='5em'
        height="50px"
      >
        {buttonText}
      </Button>
    </Box>
  )
}

export default PublishedDsrCtaButtonDisplay;
